import { render, staticRenderFns } from "./detail_local_delivery.vue?vue&type=template&id=3828ae8a&scoped=true"
import script from "./detail_local_delivery.vue?vue&type=script&lang=js"
export * from "./detail_local_delivery.vue?vue&type=script&lang=js"
import style0 from "./detail_local_delivery.vue?vue&type=style&index=0&id=3828ae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828ae8a",
  null
  
)

export default component.exports